import type { BacktestRun, BacktestRunSummary } from "@/types/api";
import { request } from "./transport";

export interface BacktestRunInput {
  readonly name?: string | null;
  readonly ticker: string;
  readonly date_from: string;
  readonly date_to: string;
  readonly saved_strategy_id?: string | null;
  readonly layers?: ReadonlyArray<Record<string, unknown>>;
  // Engine config overrides — all optional, server applies defaults.
  readonly capital_base?: number;
  readonly credit?: number | null;
  readonly credit_multiplier?: number | null;
  readonly cost_per_contract?: number;
  readonly slippage_per_leg?: number;
  readonly stop_loss_pct?: number | null;
  readonly stop_slippage?: number;
  readonly profit_target_pct?: number | null;
  readonly vix_filter?: number | null;
  readonly contracts?: number;
  readonly risk_pct?: number;
  readonly risk_free_rate?: number;
  readonly entry_t?: number;
}

export const backtestRuns = {
  listBacktestRuns: (params?: {
    ticker?: string;
    engine_version?: string;
    finished?: boolean;
  }) => {
    const qs = new URLSearchParams();
    if (params?.ticker) qs.set("ticker", params.ticker);
    if (params?.engine_version) qs.set("engine_version", params.engine_version);
    if (params?.finished !== undefined)
      qs.set("finished", String(params.finished));
    const q = qs.toString();
    return request<{ backtest_runs: BacktestRunSummary[] }>(
      `/backtest_runs${q ? `?${q}` : ""}`,
    );
  },

  getBacktestRun: (id: number | string) =>
    request<{ backtest_run: BacktestRun }>(`/backtest_runs/${id}`),

  createBacktestRun: (input: BacktestRunInput) =>
    request<{ backtest_run: BacktestRun }>("/backtest_runs", {
      method: "POST",
      body: JSON.stringify({ backtest_run: input }),
    }),

  deleteBacktestRun: (id: number | string) =>
    request<{ ok: true }>(`/backtest_runs/${id}`, { method: "DELETE" }),
};
